import { useEffect, useState } from "react";

// The one width the app changes shape at, rather than reflows at. The number
// is not a device size: it is where the player grid stops fitting. Six columns
// of nowrap text need about 660px, and the shell and panel take another 60 out
// of the viewport either side of it, so the grid runs out of room at roughly
// 720px. 780 leaves margin for a longer team name than the ones measured.
export const PHONE = "(max-width: 780px)";

// Subscribes to a media query and re-renders when it flips. It exists because
// some layouts have no honest narrow form - a six-column table is the example
// - and those have to be a different tree, not the same tree with columns
// hidden.
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);

    // Read once on mount as well: the query may have changed between the
    // initial render and the effect, and on the server it was never read.
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
